import { render, staticRenderFns } from "./Food.vue?vue&type=template&id=811bd472&scoped=true"
import script from "./Food.vue?vue&type=script&lang=js"
export * from "./Food.vue?vue&type=script&lang=js"
import style0 from "./Food.vue?vue&type=style&index=0&id=811bd472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811bd472",
  null
  
)

export default component.exports